import { IonPage } from '@ionic/react'
import React from 'react'
import PCRHeader from '../../../../components/pcrHeader/PCRHeader.component'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import HeaderNav from '../../../../components/headerNav/HeaderNav.component'
import VitalsStrokeScoreContent from '../content/StrokeScore.content'

const VitalsStrokeScore: React.FC = () => {
  const { t } = useTranslation()
  const history = useHistory()

  const onBackClick = () => {
    history.back()
  }

  return (
    <IonPage id='VitalsStrokeScaleScoreContent'>
      <PCRHeader />
      <HeaderNav
        prevOnClick={onBackClick}
        prevLabel={t('common.buttons.Back')}
        title={t('vitals.strokeScore.StrokeScore')}
        isBackButton={true}
      />
      <VitalsStrokeScoreContent />
    </IonPage>
  )
}

export default VitalsStrokeScore
